/**
 * This object represents a study of the system. In this object information about the study
 * taken together and saved. These informations are only the basic.
 */
export class Study {
    private id: String;
    private title: String;
    private name: String;
    private description: String;
    private accesstype: String;
    private password: String;
    private starts_at: number;
    private ends_at: number;
    private is_private: number;
    private is_running: boolean;
    private text: String;
    private consenttext: String;


    /**
     * Constructor of study object
     * @param id id of study
     * @param title [optional] title of study
     * @param name [optional] name of study
     * @param description [optional] description of study
     * @param accesstype [optional] accesstype of study (password/invite)
     */
    constructor(id: String, title?: String, name?: String, description?: String, accesstype?: String) {
        this.id = id;
        if (title) { this.title = title; }
        if (name) { this.name = name; }
        if (description) { this.description = description; }
        if (accesstype) { this.accesstype = accesstype; }
    }


    /**
    * This function sets the id
    * @param id id of study
    */
    public setId(id: String): void {
        this.id = id;
    }

    /**
    * This function returns the id
    * @return id of study
    */
    public getId(): String {
        return this.id;
    }

    /**
    * This function sets the title
    * @param title title of study
    */
    public setTitle(title: String): void {
        this.title = title;
    }

    /**
    * This function returns the title
    * @return title of study
    */
    public getTitle(): String {
        return this.title;
    }

    /**
    * This function sets the name
    * @param name name of study
    */
    public setName(name: String): void {
        this.name = name;
    }

    /**
    * This function returns the name
    * @return name of study
    */
    public getName(): String {
        return this.name;
    }

    /**
    * This function sets the description
    * @param description description of study
    */
    public setDescription(description: String): void {
        this.description = description;
    }

    /**
    * This function returns the description
    * @return description of study
    */
    public getDescription(): String {
        return this.description;
    }

    /**
   * This function sets the accesstype
   * @param accesstype accesstype of study
   */
    public setAccesstype(accesstype: String): void {
        this.accesstype = accesstype;
    }

    /**
    * This function returns the accesstype
    * @return accesstype of study
    */
    public getAccesstype(): String {
        return this.accesstype;
    }

    /**
    * This function sets the password
    * @param password password of study
    */
    public setPassword(password: String): void {
        this.password = password;
    }

    /**
    * This function returns the password
    * @return password of study
    */
    public getPassword(): String {
        return this.password;
    }

    /**
   * This function sets the start of a study
   * @param starts_at start of study
   */
    public setStarts_at(starts_at: number): void {
        this.starts_at = starts_at;
    }

    /**
    * This function returns the start
    * @return start of study
    */
    public getStarts_at(): number {
        return this.starts_at;
    }

    /**
   * This function sets the end of a study
   * @param ends_at start of study
   */
    public setEnds_at(ends_at: number): void {
        this.ends_at = ends_at;
    }

    /**
    * This function returns the end
    * @return end of study
    */
    public getEnds_at(): number {
        return this.ends_at;
    }

    /**
     * This function sets the is_private
     * @param is_private is_private of study
     */
    public setIs_private(is_private: number): void {
        this.is_private = is_private;
    }

    /**
    * This function returns the is_private
    * @return is_private of study
    */
    public getIs_private(): number {
        return this.is_private;
    }

    /**
     * This function sets the is_running
     * @param is_running is_running of study
     */
    public setIs_running(is_running: boolean): void {
        this.is_running = is_running;
    }

    /**
    * This function returns the is_running
    * @return is_running of study
    */
    public getIs_running(): boolean {
        return this.is_running;
    }

    /**
    * This function sets the text
    * @param text text of study
    */
    public setText(text: String): void {
        this.text = text;
    }

    /**
    * This function returns the text
    * @return text of study
    */
    public getText(): String {
        return this.text;
    }

    /**
    * This function sets the consenttext
    * @param consenttext consenttext of study
    */
    public setConsenttext(consenttext: String): void {
        this.consenttext = consenttext;
    }

    /**
    * This function returns the consenttext
    * @return consenttext of study
    */
    public getConsenttext(): String {
        return this.consenttext;
    }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/models/study.ts